// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Divider_wrapper__NeQHi","text":"Divider_text__zZjOw","line":"Divider_line__YxtjX"};